import { canValidateOpgavekompleksetTask } from '@utils/component-framework';

function makeSelectHasUninteractedTasks(component, excludedId) {
  return entry => {
    for (const task of component.tasks) {
      if (task.id === excludedId) {
        continue;
      }
      const taskEntry = entry?.data.tasks[task.id];
      const canValidate = canValidateOpgavekompleksetTask(task);
      const hasInteracted = canValidate ? Object.keys(taskEntry?.details ?? {}).length > 0 : taskEntry?.state.closed;
      const hasValidated = !!taskEntry && component.feedback.frequency.validation ? taskEntry.state.validated || taskEntry.state.skipped && taskEntry.state.closed : hasInteracted;
      if (canValidate && !hasValidated) {
        return true;
      }
    }
    return false;
  };
}

export { makeSelectHasUninteractedTasks };
//# sourceMappingURL=entry.has-uninteracted-tasks.js.map
